import React from 'react';
import { ConfirmationModal, Typography } from 'seagull';
import { useOverlayContext, useStoreActions } from "../contexts";
import { helpArticles } from "../utils/helpArticles";
import ExternalLinkButton from "../components/ExternalLinkButton";
export function useRequestPM() {
  const overlayContext = useOverlayContext();
  const {
    api,
    logBI
  } = useStoreActions();
  return async function requestPaymentMethod(agreementId) {
    const confirmed = await overlayContext.showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          title: "Request Payment Method",
          "data-testid": "request-pm-modal",
          textAlignCenter: false,
          content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "Once you send a request, your client will receive an email asking them to set up their payment details in Anchor."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, null, "Consider sending a personal message to clients still transitioning to Anchor to communicate the purpose of this request."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ExternalLinkButton, {
            openInNewTab: true,
            underline: "none",
            href: helpArticles.requestPaymentMethod()
          }, "Learn more about Request Payment Method")),
          primaryButtonLabel: "Send Request",
          primaryButtonTestid: "confirmation-modal-primary-btn",
          secondaryButtonLabel: "Cancel",
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: () => dismissModal(false)
        });
      }
    });
    if (confirmed) {
      logBI(11253);
      overlayContext.startLoader('request-pm-loader');
      try {
        await api.relationship.requestPaymentMethod(agreementId);
        overlayContext.showSuccessToast('Payment method request sent', 'request-pm-success-toast');
      } catch (err) {
        overlayContext.showErrorToast('Failed to request payment method', 'request-pm-error-toast');
      } finally {
        overlayContext.stopLoader('request-pm-loader');
      }
    }
  };
}